/// <reference path="../../global/fn.js" />

(function ($) {
    $.widget("nsp.w_mobDropdown", {
        options: {},

        _create() {
            this.wrap = this.element;

            $(window).scroll(function () {
                if ($(window).scrollTop() >= 400) {
                    $(".s-about__dropdown").addClass("fixed");
                } else {
                    $(".s-about__dropdown").removeClass("fixed");
                }
            });

            this.iniSelect();
        },

        //make sticky dropdown mobile
        iniSelect() {
            this.sel = $("select", this.wrap);

            this.sel.change(function () {
                const sectionId = this.value;
                $("html, body").animate(
                    {
                        scrollTop: $("#" + sectionId).offset().top - 150,
                    },
                    2000,
                );
                if (history.pushState) {
                    history.pushState(null, "", "#" + sectionId);
                }
            });
        },
    });
})(jQuery);
